// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"vs_a bhc_b"};